import script from "./addevent.vue?vue&type=script&setup=true&lang=js"
export * from "./addevent.vue?vue&type=script&setup=true&lang=js"

import "./addevent.vue?vue&type=style&index=0&id=3cc07866&scoped=true&lang=css"
import "./addevent.vue?vue&type=style&index=1&id=3cc07866&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cc07866"]])

export default __exports__